module.exports = __webpack_public_path__ + "static/media/boa-hancock.69f38a87.png";